import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DemographicsWorkflow } from '@/components/annotation/demographics-workflow';

export function DemographicsPage() {
  const navigate = useNavigate();

  const handleComplete = (participantId: string) => {
    console.log('Demographics completed:', participantId);
    navigate('/annotation');
  };

  const handleError = (error: string) => {
    console.error('Demographics error:', error);
  };

  return (
    <DemographicsWorkflow 
      onComplete={handleComplete}
      onError={handleError}
    />
  );
}